import { NavigateFunction } from 'react-router-dom';

export function handleListItemClick(
	route: any,
	navigate: NavigateFunction,
	setCurrentPage: (value: string) => void
): () => void {
	return function () {
		navigate(route.url);
		setCurrentPage(route.url);
	};
}

export function handleUserInfoClick(
	currentStatus: boolean,
	setStatus: (status: boolean) => void
): React.MouseEventHandler<HTMLButtonElement> {
	return function (e) {
		e.stopPropagation();
		setStatus(!currentStatus);
	};
}
